const { PRODUCTION, GLOBAL } = require('../constant');
const config = require('./config');

module.exports = {
  ...config,
  buildEnv: PRODUCTION,
  site: GLOBAL,
};
